var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeHb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "5 6 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8308_3447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 21.1236C11.4844 21.1236 9.1875 19.8111 7.92969 17.6236C6.67188 15.4635 6.67188 12.8111 7.92969 10.6236C9.1875 8.46347 11.4844 7.12363 14 7.12363C16.4883 7.12363 18.7852 8.46347 20.043 10.6236C21.3008 12.8111 21.3008 15.4635 20.043 17.6236C18.7852 19.8111 16.4883 21.1236 14 21.1236ZM12.6875 16.9127C12.7695 16.94 12.8242 16.9674 12.8789 16.9947L13.5625 17.4322C13.7812 17.5689 14 17.6236 14.2188 17.6236C14.6016 17.6236 14.9297 17.4596 15.1758 17.1861L15.5039 16.7486C15.6406 16.5572 15.75 16.3111 15.75 16.0377C15.75 15.7916 15.6406 15.5455 15.5039 15.3268L15.0117 14.6978C14.875 14.5338 14.7656 14.3424 14.6836 14.151L14.4102 13.44C14.3555 13.3307 14.2461 13.276 14.1367 13.276C14.0547 13.276 13.9453 13.3033 13.8906 13.3853L13.6172 13.7682C13.4805 13.9596 13.2617 14.0416 13.0703 13.9869C12.9609 13.9596 12.8789 13.9322 12.8242 13.8502L12.7148 13.6861C12.5234 13.4127 12.1953 13.276 11.8672 13.276C11.5391 13.276 11.2383 13.4127 11.0469 13.6861L10.8828 13.8775C10.8555 13.9322 10.8008 13.9869 10.7188 14.0143L9.76172 14.4518C9.21484 14.7252 8.96875 15.4088 9.26953 15.9557L9.35156 16.1197C9.59766 16.5846 10.1445 16.8307 10.6641 16.6666L11.0742 16.5299C11.2656 16.4752 11.457 16.4752 11.6211 16.5299L12.6875 16.9127ZM14.4648 11.0338C14.2188 10.7877 13.8359 10.651 13.4805 10.733L12.4414 10.9518C12.0039 11.0338 11.9492 11.608 12.332 11.7721L13.5078 12.2916C13.6445 12.3463 13.8086 12.3736 13.9453 12.3736H14.7656C15.1484 12.3736 15.3672 11.9088 15.0938 11.6353L14.4648 11.0338ZM13.7812 18.9361C13.7812 19.1822 13.9727 19.3736 14.2188 19.3736H14.6562C14.875 19.3736 15.0938 19.1822 15.0938 18.9361C15.0938 18.7174 14.875 18.4986 14.6562 18.4986H14.2188C13.9727 18.4986 13.7812 18.7174 13.7812 18.9361ZM18.7852 15.2994C18.7031 15.0807 18.457 14.9439 18.2383 15.026C17.9922 15.108 17.8828 15.3541 17.9375 15.5728L18.1562 16.2291C18.2383 16.4752 18.4844 16.5846 18.7305 16.5299C18.9492 16.4478 19.0859 16.2018 19.0039 15.9557L18.7852 15.2994ZM18.2383 17.5143C18.4023 17.3502 18.4023 17.0494 18.2383 16.8853C18.0742 16.7213 17.7734 16.7213 17.6094 16.8853L16.7344 17.7603C16.5703 17.9244 16.5703 18.2252 16.7344 18.3893C16.8984 18.5533 17.1992 18.5533 17.3633 18.3893L18.2383 17.5143Z",
    fill: "#ADF106"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8308_3447",
    x: -2.32812,
    y: -1.87637,
    width: 32.6289,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.945098 0 0 0 0 0.0235294 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8308_3447"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8308_3447",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeHb);
export default ForwardRef;